import React from 'react';
import PropTypes from 'prop-types';

import { Title } from 'src/core/components';

import './DetailRowStyle.scss';

const DetailRow = ({ label, value, inline, dots, notificationMsg = false }) => (
  <div className={`dna-details-row${inline ? ' dna-details-row--inline' : ''}`}>
    <Title
      className={`dna-details-row__label${dots ? '--dots' : ''}`}
      message={label}
      size="5"
    />
    <div className={!notificationMsg ?
      'dna-details-row__value' : 'dna-details-row__notification'}
    >
      {value}
    </div>
  </div>
);

DetailRow.propTypes = {
  label: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  dots: PropTypes.bool,
  inline: PropTypes.bool,
  notificationMsg: PropTypes.bool
};

export default DetailRow;
